import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    /* Colors */
    --primary-100-light: #E9FCFF;
    --primary-200-light: #79C8D4;
    --primary-800-light: #26849D;
    --primary-900-light: #207693;

    --neutral-0: #EFF1F2;
    --neutral-2: #D9D9D9;
    --neutral-3: #D2D6D6;
    --neutral-4: #787B7E;
    
    --absolute-black: #676767;
    --absolute-white: #F5F7FA;

    /* Radius */
    --radius-small: 10px;
    --radius-default: 17.25px;

    /* Spacement */
    --spacement-small: 4px;
    --spacement-default: 8px;
    --spacement-medium: 16px;
    --spacement-large: 24px;
    --spacement-xlarge: 32px;
    --spacement-xxlarge: 40px;

    /* Font Size */
    --font-size-small: 14px;
    --font-size-xsmall: 12px;
    --font-size-xxsmall: 10px;
    --font-size-default: 16px;
    --font-size-large: 18px;
    --font-size-xlarge: 20px;
    --font-size-xxlarge: 24px;
    --font-size-xxxlarge: 28px;
    --font-size-xxxxlarge: 32px;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    input[type='date']::-webkit-calendar-picker-indicator,
    input[type='time']::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
    }
  }
`;

